<template>
    <div class="page-wrapper">
        <NavBar class="style1" />
        <div class="content-wrapper">
            <PageTitle pageTitle="Prévisualisation de l'article" />
            <PreviewArticle />
        </div>
        <FooterComp />
    </div>
</template>

<script>
import NavBar from '../Layouts/NavBar'
import PageTitle from '../Common/PageTitle'
import PreviewArticle from '../ViewArticle/PreviewArticle'
import FooterComp from '../Layouts/FooterComp'

export default {
    name: 'ViewArticlePage',
    components: {
        NavBar,
        PageTitle,
        PreviewArticle,
        FooterComp,
    }
}
</script>